<template>
  <video id="video_player" ref="videoPlayer" class="video-js vjs-fill"></video>
</template>

<script>
import videojs from "video.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { setTimeout } from "timers";
import Vue from "vue";
export default {
  name: "VideoScreen",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    clips: {
      type: Object,
      default() {
        return {};
      }
    },
    videoURL: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    time: "",
    previousKey: "none",
    shortcuts: {
      KeyI: "markIn",
      KeyO: "markOut",
      KeyM: "saveClip",
      KeyP: "playClip",
      Delete: "deleteClip",
      KeyJ: "shuttleBack",
      KeyL: "shuttleFwd",
      KeyF: "fullScreen",
      Space: "playVideo",
      ArrowLeft: "stepBack",
      ArrowRight: "stepFwd"
    },
    VideoData: {},
    timer: null
  }),
  computed: {
    ...mapState({
      clip: state => state.clip,
      actionsBtns: state => state.actionsBtns.btnPressed,
      portal: state => state.portal,
      gID: state => state.report.gameID,
      gameID: state => state.game.gameID,
      actionsResult: state => state.actionsBtns.result
    })
  },
  watch: {
    actionsBtns: {
      handler(val) {
        // console.log("Action video.js: " + JSON.stringify(val, null, 2));
        this[val]();
      },
      deep: true
    },
    videoURL() {
      this.VideoData = this.videoURL;
    }
  },
  methods: {
    playerInitialise() {
      this.player = videojs(
        this.$refs.videoPlayer,
        this.options,
        function onPlayerReady() {
          // console.log("onPlayerReady", this);
        }
      );
    },
    //save clip to firestore
    saveClip() {
      //console.log("save active clip" + JSON.stringify(this.clip.active, null, 2));
      this.$store.dispatch("clip/createClip", [
        this.admin.Collection,
        this.clip.active,
        "clip/setClipResult"
      ]);
      //this.readClips();
      //console.log("GAME ID 2: " + this.gameID);
      this.readGameClips();
      Vue.notify({
        group: "clip",
        title: "Important message",
        text: "The clip has been saved",
        type: "success"
      });
    },
    //reset current clip video information
    deleteClip() {
      this.$store.commit("clip/setActiveValue", ["clipStart", "00:00"]);
      this.$store.commit("clip/setActiveValue", ["clipEnd", "00:00"]);
      this.$store.commit("clip/setActiveValue", ["clipDuration", "00:00"]);
    },
    readGameClips() {
      this.$store.dispatch("clip/getClipsByGame", [
        "clips",
        this.portal.active.id,
        this.gameID,
        "clip/setSponByGameResult"
      ]);
    },
    //update table
    readClips() {
      this.$store.dispatch("clip/readClips", [
        "clips",
        this.portal.active.id,
        "clip/setClips"
      ]);
    },
    //to display in video tabs
    showStartTime() {
      var time = this.getVideoTimeMoment();
      // console.log("Here: " + time);
      this.$store.commit("clip/setValue", ["clipStart", time]);
    },
    //mark the start of the clip
    markIn() {
      var markInTime = this.getVideoTimeMoment();
      // console.log("Mark in: " + markInTime);
      this.$store.commit("clip/setActiveValue", ["clipStart", markInTime]);
      return markInTime;
    },
    //mark the end of the clip
    markOut() {
      var markOutTime = this.getVideoTimeMoment();
      // console.log("Mark out: " + markOutTime);
      this.$store.commit("clip/setActiveValue", ["clipEnd", markOutTime]);
      var start = this.clip.active.clipStart;
      var duration = markOutTime - start;
      // console.log("Marked clip duration: " + duration);
      this.$store.commit("clip/setActiveValue", ["clipDuration", duration]);
      return markOutTime;
    },
    //play clip keyP
    playClip() {
      this.player.play();
      this.getVideoDuration();
    },
    //pause player
    playerPause() {
      this.player.pause();
    },
    //fullscreen +add method
    fullScreen() {
      var elem = document.documentElement;
      if (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      ) {
        if (!this.isFullscreen) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
            this.isFullscreen = true;
            return;
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
            this.isFullscreen = true;
            return;
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
            this.isFullscreen = true;
            return;
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
            this.isFullscreen = true;
            return;
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            this.isFullscreen = false;
            return;
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
            this.isFullscreen = false;
            return;
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            this.isFullscreen = false;
            return;
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
            this.isFullscreen = false;
            return;
          }
        }
      }
    },
    //play/pause video - space
    playVideo() {
      if (this.player.paused()) {
        this.player.play();
        this.getVideoTimeMoment();
        this.getVideoDuration();
      } else {
        this.player.pause();
        this.getVideoTimeMoment();
      }
    },
    //format time
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    //return video current time and playback rate
    getVideoTimeMoment() {
      var time = this.player.currentTime();
      // console.log("Time: " + time);
      this.$store.commit("clip/setValue", ["clipCurrentTime", time]);
      var pbRate = this.player.playbackRate();
      // console.log("Playback rate: " + pbRate);
      this.$store.commit("clip/setValue", ["clipSpeed", pbRate]);
      return time;
    },
    //return the video duration
    getVideoDuration() {
      var duration = this.player.duration();
      duration = this.changeTimeFormat(duration);
      // console.log("Duration: " + duration);
      this.$store.commit("clip/setValue", ["clipEntireDuration", duration]);
      return duration;
    },
    /*onkey(key, v) {
      var currentKey = event.code;
      // console.log("k=" + currentKey);
      // added to prevent multiple save  
      var previousKey =  v.clip.previousKey;
      // console.log("previousKey = " , + previousKey)
       if (checkEventCode.shortcuts[event.code] !== undefined) {
        if (previousKey !== "none") {
          // console.log("Previous Key was not null")
          checkEventCode[checkEventCode.shortcuts[event.code]]();
        } else if (previousKey !== key) {
          // console.log("Previous Key was not the same")
          checkEventCode[checkEventCode.shortcuts[event.code]]();
        } else {
          // console.log("Skip key pressed twice")
        }        
        v.$store.commit("clip/setPreviousKey", currentKey);

  } else {
      // // console.log("Ignored");
      }

    },*/
    //set video playback rate
    changeVideoSpeed(val) {
      this.player.playbackRate(val);
    },
    //speed up the video
    shuttleFwd() {
      var newPbRate = this.player.playbackRate() + 0.1;
      this.changeVideoSpeed(newPbRate);
      // console.log("Playback rate: " + newPbRate);
      this.$store.commit("clip/setValue", ["clipSpeed", newPbRate]);
      return newPbRate;
    },
    //speed down the video
    shuttleBack() {
      if (this.player.playbackRate() != 0) {
        var newPbRate = this.player.playbackRate() - 0.1;
        this.changeVideoSpeed(newPbRate);
        // console.log("Playback rate: " + newPbRate);
        this.$store.commit("clip/setValue", ["clipSpeed", newPbRate]);
        return newPbRate;
      } else {
        // console.log("low speed");
      }
    },
    //move video by 1 frame forward
    stepFwd() {
      var newTime = this.player.currentTime() + 0.1;
      this.player.currentTime(newTime);
      newTime = this.changeTimeFormat(newTime);
      // console.log("New time: " + newTime);
      //this.player.play();
    },
    //move video by 1 frame backwards
    stepBack() {
      var newTime = this.player.currentTime() - 0.1;
      this.player.currentTime(newTime);
      newTime = this.changeTimeFormat(newTime);
      // console.log("New time: " + newTime);
      //this.player.play();
    },
    convertSecToMS(sec) {
      var ms = parseInt(sec * 1000);
      sec = ms;
      return sec;
    },
    //play video from a certain moment
    playVideoMoment() {
      var startMoment = this.actionsResult[0];
      var duration = this.actionsResult[1];
      this.clip.clipSpeed = "1";
      this.player.playbackRate(1);
      console.log("speed: " + this.clip.clipSpeed);
      duration = this.convertSecToMS(duration);
      // console.log("Video start moment: " + startMoment + "\nVideo duration: " + duration);
      this.player.currentTime(startMoment);
      if (this.player.paused()) {
        this.player.play();
      } else {
        this.player.pause();
      }
      var v = this;
      //pause video when it reaches the end point
      setTimeout(function() {
        v.player.pause();
      }, duration);
    },
    playMoment() {
      var startMoment = this.actionsResult[0];
      this.player.currentTime(startMoment);
    },
    displayVideoCurrentTime() {
      var v = this;
      v.timer = setInterval(function() {
      var whereYouAt = v.player.currentTime();
        v.clip.clipCurrentTime = whereYouAt;
      }, 400);
      return v.timer;
    }
  },
  mounted() {
    this.playerInitialise();
    this.$store.commit("clip/setActiveValue", [
      "portalID",
      [this.portal.active.id]
    ]);
    var v = this;
    document.addEventListener("keydown", function(event) {
      var previousKey = v.previousKey;
      var currentKey = event.code;
      //console.log("event = ", JSON.stringify(event.code, null, 2))
      //console.log("currentKey = ", currentKey)
      //console.log("previousKey = " , previousKey)

      if (v.shortcuts[event.code] !== undefined) {
        if (currentKey === "KeyM" && previousKey === "KeyM") {
          //console.log("Current and Previous Key was KeyM - Ignore Save")
        } else {
          //console.log("Save Clip")
          v[v.shortcuts[event.code]]();
        }
        v.previousKey = event.code;
      }
    });
    v.displayVideoCurrentTime();
  },
  beforeDestroy() {
    var v = this;

    window.removeEventListener("keydown", v.onkey, v);

    if (this.player) {
      this.player.dispose();
    }

    clearInterval(v.timer);
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
